import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';


export class VueProvider {

    static init(): void {
        
        
        new Vue({
            el: '#app',
            //store,
            data: {},
            methods: {}
        });

        Vue.use(VueAxios, axios);
    }


    static getInstance(): Vue.VueConstructor {
        let norriqVue = Vue.extend({
        });
        return norriqVue;
    }

}

